import React from 'react';
import classNames from 'classnames';
import Icons from '../../../components/Icons/Icons';
import { IconReviewStar } from '../../../components';

import css from './Sections.module.css';

function SectionsProjects() {
  return (
    <div className={classNames(css.sectionProject, css.sectionPadding)}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <h2 className={css.sectionTitle}>Popular projects near you</h2>
        </div>
        <div className={css.popularProjects}>
          <div className={css.project}>
            <div className={css.projectIcon}>
              <Icons name="roof" />
            </div>
            <div className={css.projectInfo}>
              <h3>Decks & Porches</h3>
              <div className={css.rating}>
                <IconReviewStar /> 3.5 (1k)
              </div>
              <p className={css.price}>$1590</p>
            </div>
          </div>
          <div className={css.project}>
            <div className={css.projectIcon}>
              <Icons name="roof" />
            </div>
            <div className={css.projectInfo}>
              <h3>Decks & Porches</h3>
              <div className={css.rating}>
                <IconReviewStar /> 3.5 (1k)
              </div>
              <p className={css.price}>$1590</p>
            </div>
          </div>
          <div className={css.project}>
            <div className={css.projectIcon}>
              <Icons name="roof" />
            </div>
            <div className={css.projectInfo}>
              <h3>Decks & Porches</h3>
              <div className={css.rating}>
                <IconReviewStar /> 3.5 (1k)
              </div>
              <p className={css.price}>$1590</p>
            </div>
          </div>
          <div className={css.project}>
            <div className={css.projectIcon}>
              <Icons name="roof" />
            </div>
            <div className={css.projectInfo}>
              <h3>Decks & Porches</h3>
              <div className={css.rating}>
                <IconReviewStar /> 3.5 (1k)
              </div>
              <p className={css.price}>$1590</p>
            </div>
          </div>
          <div className={css.project}>
            <div className={css.projectIcon}>
              <Icons name="roof" />
            </div>
            <div className={css.projectInfo}>
              <h3>Decks & Porches</h3>
              <div className={css.rating}>
                <IconReviewStar /> 3.5 (1k)
              </div>
              <p className={css.price}>$1590</p>
            </div>
          </div>
          <div className={css.project}>
            <div className={css.projectIcon}>
              <Icons name="roof" />
            </div>
            <div className={css.projectInfo}>
              <h3>Decks & Porches</h3>
              <div className={css.rating}>
                <IconReviewStar /> 3.5 (1k)
              </div>
              <p className={css.price}>$1590</p>
            </div>
          </div>
          <div className={css.project}>
            <div className={css.projectIcon}>
              <Icons name="roof" />
            </div>
            <div className={css.projectInfo}>
              <h3>Decks & Porches</h3>
              <div className={css.rating}>
                <IconReviewStar /> 3.5 (1k)
              </div>
              <p className={css.price}>$1590</p>
            </div>
          </div>
          <div className={css.project}>
            <div className={css.projectIcon}>
              <Icons name="roof" />
            </div>
            <div className={css.projectInfo}>
              <h3>Decks & Porches</h3>
              <div className={css.rating}>
                <IconReviewStar /> 3.5 (1k)
              </div>
              <p className={css.price}>$1590</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionsProjects;
